export default __webpack_public_path__ + "static/media/PRESTA_SEP_3.bc923d80.jpg";